app.filterDropdown = {
    settings: {
        $btn: $('.filter-dropdown__trigger'),
        $content: $('.filter-dropdown__content'),
        $wrapper: $('.filter-dropdown')
    },

    init: function() {
        app.filterDropdown.settings.$btn.on('click', function(e){
            $(this).closest(app.filterDropdown.settings.$wrapper).find(app.filterDropdown.settings.$content).slideToggle(100);
            $(this).closest(app.filterDropdown.settings.$wrapper).find('.icon').toggleClass("icon--up");
        });
    }
};